import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    TextButton,
    Spacer,
    Text,
    Button,
    LabeledControl,
    Label,
    Checkbox,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

import UserPermissionsConstants from 'app/shared/constants/UserPermissionsConstants';
import UserManagementActions from 'app/shared/actions/UserManagementActions';

import './style.scss';

const { COMPANY_ADMIN, COMPANY_USER } = UserPermissionsConstants.PERMISSIONS;

const propTypes = {
    onNextStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const Role = ({
    onNextStep,
    onCancel,
    dispatch,
    currentUser,
    onBack,
    handleSaveComplete,
}) => {
    const { isInvitation } = currentUser;
    const isAdmin = currentUser.permissions[COMPANY_ADMIN];
    const isUser = !isAdmin && currentUser.permissions[COMPANY_USER];
    const isUserTypeSet = currentUser.permissions[COMPANY_ADMIN] || currentUser.permissions[COMPANY_USER];

    const handleSetAdmin = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [COMPANY_ADMIN]: true,
            [COMPANY_USER]: false,
        };

        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    const handleSetUser = () => {
        const newPermissions = {
            ...currentUser.permissions,
            [COMPANY_ADMIN]: false,
            [COMPANY_USER]: true,
        };
        dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    };

    return (
        <div>
            <Spacer marginY="sm">
                <Text>
                    {`Select user role - Do you want to make ${currentUser.userName} a company admin, or a user?`}
                </Text>
            </Spacer>
            <Spacer>
                <LabeledControl
                    label={<Label>Company Admin - Full access to properties and features. Can invite others.</Label>}
                    control={(
                        <Checkbox
                            onChange={handleSetAdmin}
                            checked={isAdmin}
                        />
                    )}
                />
                <LabeledControl
                    label={<Label>User - Customizable access to properties and features. Cannot invite others.</Label>}
                    control={(
                        <Checkbox
                            onChange={handleSetUser}
                            checked={isUser}
                        />
                    )}
                />
            </Spacer>
            <HR />
            <div className="Questions-footer">
                <TextButton className="Role-button" onClick={onCancel}>
                    Cancel
                </TextButton>
                <div>
                    <TextButton className="Questions-button" onClick={onBack}>
                        Back
                    </TextButton>
                    {isInvitation || (!isAdmin && !isInvitation)
                        ? (
                            <Button buttonType="primary" onClick={onNextStep} disabled={!isUserTypeSet}>
                                Continue
                            </Button>
                        )
                        : (
                            <Button
                                buttonType="primary"
                                onClick={() => dispatch(UserManagementActions.editableUserSave())
                                    .then(handleSaveComplete)}
                            >
                                Save
                            </Button>
                        )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    currentUser: state.userManagement.currentUser,
});

Role.propTypes = propTypes;

export default connect(mapStateToProps)(Role);
